import React from 'react';
export function SymptomsSection() {
  return <section className="bg-gradient-hero py-16 md:py-20 px-5 md:px-8" data-id="element-309" data-mp="3m583tb1wc66r">
      <div className="max-w-[1400px] mx-auto flex flex-col items-center text-center" data-id="element-310" data-mp="b4h3vznaczgi">
        <div className="text-center max-w-md mx-auto" data-id="element-311" data-mp="3sms7ev53j7lm">
          <h3 className="font-display text-[32px] leading-tight text-foreground" data-id="element-312" data-mp="3sk608wm4au3x">
            ¿Te reconocés en alguna de estas situaciones?
          </h3>

          <ul className="mt-8 space-y-6 text-left" data-id="element-313" data-mp="3jk93s8thkqyb">
            <li className="font-body text-foreground/80" data-id="element-314" data-mp="3nmxfqpdhydzi">
              <p className="text-[18px]" data-id="element-315" data-mp="3nogwsi6z8t2c">✓ Dormís pero no descansás.</p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-316" data-mp="39nxt1n9jo95z">
                Ocho horas y aun así necesitás café para funcionar.
              </p>
            </li>

            <li className="font-body text-foreground/80" data-id="element-317" data-mp="17vrn8dvau5zp">
              <p className="text-[18px]" data-id="element-318" data-mp="17wb03g63e46v">
                ✓ Tu cintura cambió aunque comés parecido.
              </p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-319" data-mp="1csrswno8l6qa">
                La ropa que antes te quedaba bien hoy no cierra igual.
              </p>
            </li>

            <li className="font-body text-foreground/80" data-id="element-320" data-mp="2wh8qtpftdqy3">
              <p className="text-[18px]" data-id="element-321" data-mp="3a9omu6aasopi">✓ Hay días donde no te sentís vos.</p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-322" data-mp="367jurbzi004z">
                Te mirás al espejo y sentís que no reconocés a la persona
                que ves.
              </p>
            </li>

            <li className="font-body text-foreground/80" data-id="element-323" data-mp="2dj5wcv4hz1sw">
              <p className="text-[18px]" data-id="element-324" data-mp="2dkqsuqadgute">✓ Ansiedad, antojos e hinchazón.</p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-325" data-mp="2rjgpy5x6yuhr">
                Aparecen a la tarde, sin aviso, y cuesta pararlos.
              </p>
            </li>

            <li className="font-body text-foreground/80" data-id="element-326" data-mp="6rwzx6b0quy6">
              <p className="text-[18px]" data-id="element-327" data-mp="6uj6p3q356fc">
                ✓ Todo lo que antes funcionaba dejó de funcionar.
              </p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-328" data-mp="2vllfndun70xj">
                La dieta y la rutina que te servían durante años ahora no
                hacen nada.
              </p>
            </li>

            <li className="font-body text-foreground/80" data-id="element-329" data-mp="34lhyuzy9j7l7">
              <p className="text-[18px]" data-id="element-330" data-mp="34jx3x981dmmt">
                ✓ Te exigís igual pero tu cuerpo ya no responde igual.
              </p>
              <p className="text-[14px] text-foreground/55 mt-1 pl-6" data-id="element-331" data-mp="2cv3p9fxa8hfc">
                Ponés el mismo esfuerzo de siempre y los resultados ya no
                llegan.
              </p>
            </li>
          </ul>

          {/* Imagen — cierre emocional del espejo, no apertura */}
          <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ChatGPT_Image_9_jun_2026_02_48_17_p.m_430x.jpg?v=1781031076" alt="Mujer reflexionando" loading="lazy" decoding="async" className="w-full max-w-[430px] mx-auto rounded-xl mt-10" data-id="element-332" data-mp="2qm8i9z65abgp" />

          {/* Closing card — cierra el espejo emocional y da paso al cambio de creencia */}
          <div className="card-premium p-6 md:p-7 mt-10" data-id="element-333" data-mp="1qldda00enmrt">
            <p className="font-display italic text-[#F0E8D8] text-[20px] md:text-[22px] leading-snug" data-id="element-334" data-mp="1lnbuzhaszrhe">
              "Eso es exactamente lo que me pasa."
            </p>
          </div>

          <div className="mt-10" data-id="element-335" data-mp="1gq3fxpkyc3kd">
            <p className="font-display text-[34px] leading-tight text-foreground" data-id="element-336" data-mp="1cnf376t4aci4">
              No necesitás más esfuerzo.
            </p>

            <p className="font-display italic text-[#C8A870] text-[30px] leading-tight mt-2" data-id="element-337" data-mp="17ovfp1yvksnn">
              Necesitás un sistema que te guíe en esta etapa.
            </p>
            <div className="mt-8 mb-10 max-w-md mx-auto text-center" data-id="element-338" data-mp="xysp18f87qsh"></div>
          </div>
        </div>
      </div>
    </section>;
}